import { useState } from 'react';
import { useAuth } from '@/stores/auth';
import { Card } from '@/components/ui/Card';
import { BankAccountForm, type BankAccountValues } from '@/components/seller/BankAccountForm';
import { toast } from '@/components/ui/Toast';
import { callUpdateBankAccount } from '@/lib/callables';

export default function PaymentSettingsPage() {
  const { userDoc } = useAuth();
  const masked = userDoc?.sellerProfile?.bankAccount?.accountNumberMasked;
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (v: BankAccountValues) => {
    setSubmitting(true);
    try {
      await callUpdateBankAccount(v);
      toast.success('Bank account saved.');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="mx-auto max-w-xl px-6 py-6">
      <h1 className="font-display text-3xl">Payment</h1>

      {userDoc?.roles?.seller ? (
        <Card className="mt-6 space-y-4">
          <h2 className="font-display text-xl">Bank account for payouts</h2>
          {masked && <p className="text-sm text-makhe-ink/70">Current: {masked}</p>}
          <BankAccountForm onSubmit={onSubmit} submitting={submitting} />
        </Card>
      ) : (
        <Card className="mt-6">
          <p className="text-sm text-makhe-ink/70">
            Only sellers need a payout account. Buyers pay via Paystack at checkout.
          </p>
        </Card>
      )}
    </section>
  );
}
